import angular from 'angular';

import MultiLangSameValueDirective from './components/multi-lang-same-value-directive';
import RwLanguagePickerComponent from './components/rw-language-picker/rw-language-picker-component';
import RwLanguageSelectComponent from './components/rw-language-select/rw-language-select-component';
import RwMultiLanguagePageComponent from './components/rw-multilanguage-page/rw-multilanguage-page-component';

export default angular
  .module('multi-language', [])
  .directive('multiLangSameValue', () => new MultiLangSameValueDirective())
  .component('rwLanguagePicker', new RwLanguagePickerComponent())
  .component('rwLanguageSelect', new RwLanguageSelectComponent())
  .component('rwMultiLanguagePage', new RwMultiLanguagePageComponent());



// WEBPACK FOOTER //
// ./src/modules/utils/multilanguage/multilanguage-module.js